import React, { useContext, useEffect, useState } from "react";
import { Row,Col,Container,Button} from 'react-bootstrap';
import { toast } from "react-toastify";
import GetNFT from '../components/page-components/getNFT';

import { getAccountWaveBalance, getAccountAssetBalance, getAdoptionAmount, convertTokentoNormalAmount } from "../components/blockchain functions/BlockchainFunctions";
import { LoginContext } from "../context/LoginContext";
import { startPandaAdoption, finishPandaAdoption } from "../components/contract functions/Adoption";
//icons
import adoption from '../components/assets/icons/giftbox-gift.svg';
import loadingIcon from '../components/assets/Rhombus.gif';

const Adoption=()=>{
  const [loginData, setLoginData] =  useContext(LoginContext);
  const [adoptTx, setAdoptTx] =  useState("");
  const [timer, setTimer] =  useState(120);
  const [adoptionAmount, setAdoptionAmount] =  useState(120);
  const [disableButton, setDisableButton] =  useState(false);

  useEffect(async ()=>{
    let amount=await getAdoptionAmount();
    setAdoptionAmount(amount);
  },[]);
  
  const GetBalance=()=>{
    const [walletBalanceWave, setWalletBalanceWave] =  useState(0);
    const [walletBalanceAsset, setWalletBalanceAsset] =  useState(0);

    useEffect(async ()=>{
      setWalletBalanceWave(await getAccountWaveBalance(loginData.walletAddress));
      setWalletBalanceAsset(await getAccountAssetBalance(loginData.walletAddress));
    },[]);

    return(
        <span>{walletBalanceAsset} PANDAS<br/>{walletBalanceWave}</span>
    );
  }

  const startCountdown=()=>{
    var i=120;
    var countdown = setInterval(function() {
      setTimer(i);
      i--;
      if(i<0){
        clearInterval(countdown);
        toast.info("Wait is Over!\n You can finish Adoption now!");
      }
    }, 1000);
  }

  const adoptStart=async ()=>{
    if(await getAccountAssetBalance(loginData.walletAddress)<1){
      toast.error("You don't have enough PANDAS tokens");
      return;
    }
    var tx=await startPandaAdoption(adoptionAmount,loginData.phrase);
    console.log(tx);
    setAdoptTx(tx.id);
    startCountdown();//call countdown
  }

  const adoptFinish=async ()=>{
    setDisableButton(true);
    let result= await finishPandaAdoption(adoptTx,loginData.phrase);
    if(result){
      setAdoptTx("");
      setTimer(120);
      toast.success('Adopted successfully!');
    }
  }

    return(
        <>
        <div className="page-heading">
            <h2><img style={{height:"3rem"}} src={adoption}/> Adoption</h2>
            <span>Here you can adopt NFT!</span>
        </div>
            <hr/>
            <Container>
              <Row>
                <Col sm={3}>
                  <div className="nftData">
                      <GetNFT nftName="PANDA-4023933-A"/>
                    <div className="details d-grid gap-2">
                      {adoptTx=="" ?
                      <>
                        <span></span>
                        <span><span className="fw-bold">Available Balance</span> : <GetBalance/> Waves</span>
                        <span></span>
                        <Button variant="outline-primary" onClick={adoptStart} disabled={loginData==null||loginData?.phrase==""}>
                           Adopt for {(adoptionAmount/100000000).toFixed(2)} PANDAS Token </Button>
                      </>
                      :
                      timer>0?
                      <>
                      <div style={{textAlign:"center"}}> <img style={{height:"3rem"}} src={loadingIcon}/></div>
                      <label>Wait for {timer} seconds</label>
                      <label>Note: Please don't leave page till finishing the Adoption or you will loss your NFT</label>
                      </>:
                      <Button variant="outline-primary" onClick={adoptFinish} disabled={disableButton}>Finish Adoption</Button>
                      }
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
        </>
    )
}

export default Adoption